import React from "react";
import styles from "../../../styles/screens/AmritjalProductDetail/AmritjalSpray/ProductLandingSpray.module.css";
import amritjalRose from "../../../assets/amritjal_hp/amritjal-rose.png";
import amritjalClassic from "../../../assets/amritjal_hp/spray.png";
//import mandala from "../../../assets/amritjal_hp/flower-new.png";
const ProductLandingSpray = ({ productId }) => {
  return (
    <div className={styles.benefitsContainer}>
      {/* <div className={styles.flowerPattern}>
        <img src={mandala} alt="" className={styles.flowerImage} />
      </div> */}

      <div className={styles.contentWrapper}>
        <div className={styles.productSection}>
          <img
            src={
              productId === "amritjal-spray" ? amritjalClassic : amritjalRose
            }
            alt="Amrit Jal bottle"
            className={styles.productImage}
          />
        </div>
        {productId === "amritjal-spray" ? (
          <div className={styles.benefitsSection}>
            <h1 className={styles.mainHeading}>
              Benefits of
              <br />
              Mahakumbh Jal
            </h1>
            {productId === "amritjal-spray" && (<h2 style={{color:"#ff8c42"}}>Packed as Amrit Jal spray</h2> ) }
            <div className={styles.benefitItem}>
              <h2 className={styles.benefitTitle}>
              Easy to Use
              </h2>
              <p className={styles.benefitDescription}>
              Carry the sacred water with you wherever you go, allowing yourself to remain connected to a sense of divine presence.
              </p>
            </div>

            <div className={styles.benefitItem}>
              <h2 className={styles.benefitTitle}>
              Mess Free
              </h2>
              <p className={styles.benefitDescription}>
              No spillage, no wastage—preserve the sacred essence with care, ensuring nothing is lost.
              </p>
            </div>

            <div className={styles.benefitItem}>
              <h2 className={styles.benefitTitle}>
              Impeccable Combo
              </h2>
              <p className={styles.benefitDescription}>
              Perfect for pooja, meditation, and protection, this preserves purity and enhances spiritual focus.
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.benefitsSection}>
            <h1 className={styles.mainHeading}>
              Benefits of
              <br />
              Amrit Jal
            </h1>

            <div className={styles.benefitItem}>
              <h2 className={styles.benefitTitle}>
                Instant Calm and
                <br />
                Positivity
              </h2>
              <p className={styles.benefitDescription}>
                Elevate your mood and reduce stress with a refreshing
                <br />
                spiritual mist anytime, anywhere.
              </p>
            </div>

            <div className={styles.benefitItem}>
              <h2 className={styles.benefitTitle}>
                Energize Your Daily
                <br />
                Routine
              </h2>
              <p className={styles.benefitDescription}>
                Infused with sacred ingredients, it revitalizes your energy
                <br />
                and keeps you focused.
              </p>
            </div>

            <div className={styles.benefitItem}>
              <h2 className={styles.benefitTitle}>
                Stay Connected to
                <br />
                Tradition
              </h2>
              <p className={styles.benefitDescription}>
                A modern way for youth to embrace spiritual purity
                <br />
                and cultural roots on the go.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductLandingSpray;
